import { render } from "./BulgogiBody.vue?vue&type=template&id=2970a92f&scoped=true"
import script from "./BulgogiBody.vue?vue&type=script&lang=js"
export * from "./BulgogiBody.vue?vue&type=script&lang=js"

import "./BulgogiBody.vue?vue&type=style&index=0&id=2970a92f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2970a92f"]])

export default __exports__